var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"id":"dashboard-core-footer","absolute":""}},[_c('v-container',[_c('v-row',{attrs:{"align":"center","no-gutters":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }